import * as React from 'react';
import DeleteProfilePage from '../containers/DeleteProfilePage';

export default (props) => <DeleteProfilePage {...props} />

